/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicated-branches */
// Disabling this rule because it's cleaner to have seperate switch blocks for each state,
// for readibility and as they may change in the future
/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import {
  APPOINTMENT_AUTO_BOOK_ERROR,
  APPOINTMENT_NEW,
  APPOINTMENT_NEXT_DATE_SLOT,
  APPOINTMENT_NEXT_STEP,
  APPOINTMENT_PREV_DATE_SLOT,
  APPOINTMENT_RESET,
  APPOINTMENT_UPDATE,
  APPOINTMENT_UPDATE_DATE_AND_TIMES,
  GET_AVAILABLE_DATES_FAILURE,
  GET_AVAILABLE_DATES_REQUEST,
  GET_AVAILABLE_DATES_SUCCESS,
  GET_CARD_TOKEN_FAILURE,
  GET_CARD_TOKEN_REQUEST,
  GET_CARD_TOKEN_SUCCESS,
  GET_PAYMENT_SETTING_FOR_CLIENT_FAILURE,
  GET_PAYMENT_SETTING_FOR_CLIENT_REQUEST,
  GET_PAYMENT_SETTING_FOR_CLIENT_SUCCESS,
  SUBMIT_BOOKING_CLEAR_ERROR,
  SUBMIT_BOOKING_FAILURE,
  SUBMIT_BOOKING_REQUEST,
  SUBMIT_BOOKING_RESCHEDULE_FAILURE,
  SUBMIT_BOOKING_RESCHEDULE_REQUEST,
  SUBMIT_BOOKING_RESCHEDULE_SUCCESS,
  SUBMIT_BOOKING_SUCCESS,
} from '../actions/ActionTypes';

const initialState = null;

export default function appointment(state = initialState, action) {
  switch (action.type) {
    case APPOINTMENT_NEW:
      return {
        service_guids: action.payload.selectedServices,
        professional: action.payload.professional,
        appointmentGuid: action.payload.appointmentGuid,
        appointmentToken: action.payload.appointmentToken,
        stepIndex: 0,
        slotIndex: 0,
        date: null,
        time: null,
        dateSlots: [],
        timeSlots: null,
        inHouse: null,
        addressLine1: '',
        addressLine2: '',
        cancellationPolicyAcknowledged: false,
        agreedToSmsConsent: false,
        city: '',
        zipCode: '',
        state: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        pronouns: '',
        cardNum: '',
        cardExp: '',
        cardCVC: '',
        cardZipcode: '',
        notes: '',
        loading: null,
        error: null,
        rwg_token: action.payload?.rwg_token || null,
        requireCard: null,
        status: 'pending',
      };
    case APPOINTMENT_RESET:
      return null;
    case APPOINTMENT_NEXT_STEP:
      return {
        ...state,
        stepIndex: state.stepIndex + 1,
      };
    case APPOINTMENT_NEXT_DATE_SLOT:
      return {
        ...state,
        slotIndex: state.slotIndex + 1,
        date: null,
      };
    case APPOINTMENT_PREV_DATE_SLOT:
      return {
        ...state,
        slotIndex: state.slotIndex - 1,
        date: null,
      };
    case APPOINTMENT_UPDATE: {
      const { field, value } = action.payload;

      if (typeof state[field] === 'undefined' || state[field] === value)
        return state;
      return {
        ...state,
        // Reset available time slots once the selected appointment date is changed
        [field]: value,
      };
    }
    case APPOINTMENT_UPDATE_DATE_AND_TIMES: {
      const { date, timeSlots } = action.payload;

      if (typeof date === 'undefined') return state;

      let theseTimeSlots = timeSlots;

      if (typeof timeSlots === 'undefined') {
        theseTimeSlots = null;
      }
      return {
        ...state,
        date,
        timeSlots: theseTimeSlots,
      };
    }
    case GET_AVAILABLE_DATES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_AVAILABLE_DATES_SUCCESS:
      return {
        ...state,
        dateSlots: [...action.payload],
        loading: false,
      };
    case GET_AVAILABLE_DATES_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case GET_PAYMENT_SETTING_FOR_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_PAYMENT_SETTING_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        booking_payment_settings: action.payload,
        loading: false,
      };
    case GET_PAYMENT_SETTING_FOR_CLIENT_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case GET_CARD_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_CARD_TOKEN_SUCCESS:
      return {
        ...state,
        stripe_token: action.payload,
        loading: false,
      };
    case GET_CARD_TOKEN_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case SUBMIT_BOOKING_REQUEST:
    case SUBMIT_BOOKING_RESCHEDULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SUBMIT_BOOKING_SUCCESS:
    case SUBMIT_BOOKING_RESCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        status: 'complete',
        guid: action.payload?.guid,
        address_information: action.payload?.address_information,
        status: action.payload?.status,
        form_status: action.payload?.form_status,
        ...(action.payload?.professional
          ? { professional: action.payload?.professional }
          : {}),
      };
    case SUBMIT_BOOKING_FAILURE:
    case SUBMIT_BOOKING_RESCHEDULE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case SUBMIT_BOOKING_CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case APPOINTMENT_AUTO_BOOK_ERROR:
      return {
        ...state,
        autoBookError: action.payload,
      };
    default:
      return state;
  }
}
